import { render, staticRenderFns } from "./microsoft-brand.vue?vue&type=template&id=73d34d2a"
import script from "./microsoft-brand.vue?vue&type=script&lang=js"
export * from "./microsoft-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports